export default __webpack_public_path__ + "static/media/oip.62224082.jpg";